 @import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 

/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

 /* @import url("~bootstrap/dist/css/bootstrap.min.css");   */

 :host {
  display: block;
}

/*custom */

a , a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
 
}

.colSmHeader {
  background-color: #fff;

}

.icon-image {
  border-top-left-radius: 5px;
  width: 50px;
}

.section-title {
  font-size:16px;
  margin-left:5px;
}
.section-bg {
  background: white;
  border-bottom: 1px solid red;
  height: 50px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
}


::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3; 
}